const BIRTH_DATE_DIGIT_LIMIT = 8

export const PROFILE_BIRTH_DATE_FORMAT = /^\d{2}\.\d{2}\.\d{4}$/

export function formatProfileBirthDateInput(value: string): string {
  const digits = value.replaceAll(/\D/g, '').slice(0, BIRTH_DATE_DIGIT_LIMIT)

  if (digits.length <= 2) {
    return digits
  }

  if (digits.length <= 4) {
    return `${digits.slice(0, 2)}.${digits.slice(2)}`
  }

  return `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4)}`
}

export function isValidProfileBirthDate(value: string): boolean {
  if (!PROFILE_BIRTH_DATE_FORMAT.test(value)) {
    return false
  }

  const [dayPart, monthPart, yearPart] = value.split('.')
  const day = Number(dayPart)
  const month = Number(monthPart)
  const year = Number(yearPart)

  if (day < 1 || month < 1 || month > 12) {
    return false
  }

  const daysInMonth = new Date(year, month, 0).getDate()
  return day <= daysInMonth
}
